<template>
  <div class="crmheader navbar-header">
    <b-navbar toggleable="lg" type="dark" variant="info" class="header-static py-0 ">
      <b-navbar-brand class="d-flex p-0">
        <div class="hamburger d-sm-block d-md-block d-lg-none d-xl-none">
          <i class="pi pi-align-justify" @click="OpenSidebar()"></i>
        </div>
        <div class="crmlogobg">
          <img src="../../../../assets/logo/CrmLogo.png" @click="mopcrm()" class="me-1 icon-size" />
        </div>
        <h3 class="crmheading" @click="mopcrm()">CRM</h3>
      </b-navbar-brand>
      <div class="ml-auto d-flex align-items-center">
        <div class="livecallsbg mx-3" @click="VisibleRight = true">
          <template v-if="contactTableList.length > 0">
            <p class="blink">
              Live Call<span class="ms-3">
                <Badge severity="warning">{{ contactTableList.length }}</Badge>
              </span>
            </p>
          </template>
          <template v-else>
            <p>
              Live Call<span class="ms-3">
                <Badge severity="warning">{{ contactTableList.length }}</Badge>
              </span>
            </p>
          </template>
        </div>
        <div class="appsicon mx-4">
          <img src="../../../../assets/Img/icons/appsicon.svg" class="header-images" alt=""
            @click="mobileoptiontoggle" />
          <div class="mobiletoggle" v-if="mobileoptionvisible">
            <div class="mobilelivecalls">
              <div class="livecallsbg mx-3" @click="(VisibleRight = true), (mobileoptionvisible = false)">
                <template v-if="contactTableList.length > 0">
                  <p class="blink d-flex align-items-center">Live Call</p>
                  <Badge class="ms-3" severity="warning">{{
                    contactTableList.length
                  }}</Badge>
                </template>
                <template v-else>
                  <div class="d-flex align-items-center">
                    <p>Live Call</p>
                    <Badge class="ms-3" severity="warning">{{
                      contactTableList.length
                    }}</Badge>
                  </div>
                </template>
              </div>
            </div>
            <div @click="(VisibleRightLogs = true), (mobileoptionvisible = false)">
              <div class="d-flex align-items-center">
                <div v-if="missedCallTableList.length > 0" class="blink">
                  <img src="../../../../assets/Img/icons/phoneimg.svg" class="header-images" />
                  <Badge class="callicon-badge" severity="danger">{{
                    missedCallTableList.length
                  }}</Badge>
                </div>
                <div v-else>
                  <img src="../../../../assets/Img/icons/phoneimg.svg" class="header-images" />
                </div>
                <p>Calls</p>
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center" @click="
                (VisibleNotification = true), (mobileoptionvisible = false)
                ">
                <div v-if="WhatsAppNotifications.length > 0" class="blink">
                  <img src="../../../../assets/Img/icons/whatsappimg.svg" class="header-images" />
                  <Badge class="whatsappicon-badge" severity="danger">{{
                    WhatsAppNotifications.length
                  }}</Badge>
                </div>
                <div v-else>
                  <img src="../../../../assets/Img/icons/whatsappimg.svg" class="header-images" />
                </div>
                <p>Whatsapp</p>
              </div>
            </div>
            <div @click="
              router.push({
                path: '/taskDetails',
                query: { TabValue: 'Tab4' },
              }),
              (mobileoptionvisible = false)
              " class="d-flex align-items-center">
              <div v-if="notifications.length > 0" class="blink">
                <img src="../../../../assets/Img/icons/mytask.svg" class="header-images" />
                <Badge class="notification-number-badge" severity="danger">{{
                  notifications.length
                }}</Badge>
              </div>
              <div v-else>
                <img src="../../../../assets/Img/icons/mytask.svg" class="header-images" />
              </div>
              <p>Task</p>
            </div>
            <div class="d-flex align-items-center" @click="
              router.push({ path: '/CRMcodeTemplate' }),
              (mobileoptionvisible = false)
              ">
              <img src="../../../../assets/Img/icons/codetemplateimg.svg" class="header-images" />
              <p>Code Template</p>
            </div>
            <!-- <div @click="$router.push({ path: '/CRMcodeTemplate' })" class=" pt-3">
            <i class="pi pi-sitemap" style="color: aliceblue"></i>
          </div> -->

            <div class="d-flex align-items-center" @click="
              router.push({ path: '/userdashboard' }),
              (mobileoptionvisible = false)
              ">
              <div>
                <img src="../../../../assets/Img/icons/settingimg.svg" class="header-images" />
              </div>
              <p>Settings</p>
            </div>
          </div>
        </div>
        <div class="crmsettings mx-2 notification-badge">
          <div @click="VisibleRightLogs = true">
            <div>
              <div v-if="missedCallTableList.length > 0" class="blink">
                <img src="../../../../assets/Img/icons/phoneimg.svg" class="header-images" />
                <Badge class="callicon-badge" severity="danger">{{
                  missedCallTableList.length
                }}</Badge>
              </div>
              <div v-else>
                <img src="../../../../assets/Img/icons/phoneimg.svg" class="header-images" />
              </div>
            </div>
          </div>
          <div>
            <div>
              <div v-if="WhatsAppNotifications.length > 0" class="blink" @click="VisibleNotification = true">
                <img src="../../../../assets/Img/icons/whatsappimg.svg" class="header-images" />
                <Badge class="whatsappicon-badge" severity="danger">{{
                  WhatsAppNotifications.length
                }}</Badge>
              </div>
              <div v-else>
                <img src="../../../../assets/Img/icons/whatsappimg.svg" class="header-images" />
              </div>
            </div>
          </div>
          <div @click="
            router.push({
              path: '/taskDetails',
              query: { TabValue: 'Tab4' },
            })
            ">
            <div v-if="notifications.length > 0" class="blink">
              <img src="../../../../assets/Img/icons/mytask.svg" class="header-images" />
              <Badge class="notification-number-badge" severity="danger">{{
                notifications.length
              }}</Badge>
            </div>
            <div v-else>
              <img src="../../../../assets/Img/icons/mytask.svg" class="header-images" />
            </div>
          </div>
          <div>
            <img src="../../../../assets/Img/icons/codetemplateimg.svg" class="header-images"
              @click="router.push({ path: '/CRMcodeTemplate' })" />
          </div>

          <!-- Module Switcher Icon -->
          <!-- <div>
            <img src="../../../../assets/Img/icons/apps.svg" class="header-images mx-4" style="width: 24px !important;"
              @click="ModuleSwitcherpopup = true" />
          </div> -->

          <div>
            <img src="../../../../assets/Img/icons/settingimg.svg" class="header-images"
              @click="$router.push({ path: '/userdashboard' })" />
          </div>
        </div>

        <div class="profile">
          <div class="flex justify-content-center position-relative">
            <div v-if="AgentId != 0">
              <div v-if="AgentStatus == true" class="active-indicator"></div>
              <div v-else class="inactive-indicator"></div>
            </div>
            <Avatar :label="ProfileData.UserNameFirstLetter" class="avatar header-avatar" @click="toggle"
              aria-haspopup="true" aria-controls="overlay_menu" />
            <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" class="crmprofilemenu">
              <template #start class="profile-box">
                <div class="flex flex-column align px-3 py-2 menuhead">
                  <div class="d-flex" style="gap: 10px">
                    <Avatar :label="ProfileData.UserNameFirstLetter" class="avatar header-avatar avatar-shape"
                      @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" />

                    <div>
                      <p class="menu-heading1">{{ ProfileData.UserName }}</p>
                      <p class="light-txt" style="color: coral">
                        {{ ProfileData.RoleName }}
                      </p>
                      <p class="light-txt">+91 {{ ProfileData.phoneNumber }}</p>
                    </div>
                  </div>
                  <b-row>
                    <b-col>
                      <div class="field pt-2 mb-0">
                        <Dropdown v-model="SelectedBranchId" :options="BranchDropDown.BranchOption"
                          optionLabel="BranchName" placeholder="Choose Branch" @change="BranchOnChange" />
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="field pt-2 mb-0">
                        <Dropdown v-model="SelectedRoleId" :options="RoleDropDown.RoleOption" optionLabel="RoleName"
                          placeholder="Choose Role" @change="RoleOnchange" />
                      </div>
                    </b-col>
                  </b-row>
                  <p class="d-flex flex-row-reverse blue-small-txt" @click="Changepasswordpopup = true">
                    Change Password
                  </p>
                </div>

                <button class="w-full p-link flex align-items-center text-color hover:surface-200 border-noround">
                  <i class="pi pi-sign-out" />
                  <span @click="LogOut()">Log Out</span>
                </button>
              </template>
            </Menu>
          </div>
        </div>
      </div>
      <!-- </b-navbar-nav>
    </b-collapse> -->
    </b-navbar>

    <Dialog v-model:visible="Changepasswordpopup" modal header="Change Password" :style="{ width: '50vw' }"
      @after-hide="IsClear">
      <b-container fluid>
        <b-form @submit.prevent="IsStoreSubmit">
          <b-row class="mb-4">
            <b-col lg="8" md="8" sm="12" cols="12">
              <div class="field mb-0 position-relative">
                <div class="blue-txt pwd-icon" @click="showhide()">
                  <i v-if="showpass == true" class="pi pi-eye-slash"></i>
                  <i v-else class="pi pi-eye"></i>
                </div>
                <TextField :txttype="showtxt" v-model="ChangePasswordObjVal.newpassword" placeholder=" " clearable
                  name="New Password" label="New Password" :rules="{ required: true }" id="New Password"
                  :required-icon="true" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8" md="8" sm="12" cols="12">
              <div class="field mb-0 position-relative">
                <div class="blue-txt pwd-icon" @click="confirmshowhide()">
                  <i v-if="showconfpass == true" class="pi pi-eye-slash"></i>
                  <i v-else class="pi pi-eye"></i>
                </div>
                <TextField :txttype="showConfirmtxt" v-model="ChangePasswordObjVal.confirmpassword" placeholder=" "
                  clearable name="Confirm Password" label="Confirm Password" :rules="{ required: true }"
                  id="Confirm Password" :required-icon="true" />
                <p v-if="showError" class="err_msg_style">
                  Password Must Be Same
                </p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex flex-row-reverse">
              <AddButton btnname="Save" type="submit" />
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </Dialog>

    <div class="d-flex">
      <div class="leftsidebarbg" :style="{ width: sidebarwidth }" v-bind:class="{ hovered: isHovered }"
        v-on:mouseover="hoverHandler(true)">
        <ul class="my-1 sidebarmenu">
          <li>
            <div class="d-flex align-items-center my-2">
              <Avatar :label="SelectedPipeline.value == 1 ? 'S' : 'M'"
                class="ms-2 px-xl-3 px-lg-2 px-md-3 sidebaravatar" />
              <div class="pipelinedropdown">
                <Dropdown v-model="SelectedPipeline" :required-icon="false" label="" :rules="{ required: false }"
                  :options="pipeline" optionLabel="name" name="Executive" id="Executive"
                  @update:modelValue="pipelinerouter" />
              </div>
            </div>
          </li>
          <li class="s-list" v-for="(item, index) in menuarray" :key="index" @click="TabClick(item)">
            <div class="">
              <div class="d-flex align-items-center">
                <div class="beforeselected" :class="{ selected: selectedItem === item.FixedHref }">
                  <img class="list-icon" :src="item.Image" />
                </div>
                <div class="menucontent" :class="{ selectedcontent: selectedItem === item.FixedHref }">
                  <p>{{ item["SubMenuName"] }}</p>
                </div>
              </div>
            </div>
          </li>
          <!-- <li class="s-list" @click="CallLog">
            <div class="">
              <div class="d-flex align-items-center">
                <div class="beforeselected">
                  <img class="list-icon" src="item.Image" />
                </div>
                <div class="menucontent">
                  <p>Call Log</p>
                </div>
              </div>
            </div>
          </li> -->
          <!-- <li class="s-list" @click="$router.push('/webWhatsapp')">
            <div class="">
              <div class="d-flex align-items-center">
                <div class="beforeselected">
                  <img
                    class="list-icon"
                    src="../../../../assets/Img/icons/whatsappimg.svg"
                  />
                </div>
                <div class="menucontent">
                  <p>Whatsapp</p>
                </div>
              </div>
            </div>
          </li> -->
          <!-- <li
          v-if="SelectedPipeline?.value === 1"
          class="s-list"
          v-for="item in menuItems"
          :key="item.label"
          @click="navigate(item.path)"
        >
          <div class="">
            <div class="d-flex align-items-center">
              <div
                class="beforeselected"
                :class="{ selected: selectedItem === item.path }"
              >
                <img class="list-icon" :src="item.icon" />
              </div>
              <p
                class="menucontent"
                :class="{ selectedcontent: selectedItem === item.path }"
              >
                {{ item.label }}
              </p>
            </div>
          </div>
        </li> -->
        </ul>
      </div>

      <div class="crm-router-screen" @click="handleClickOutside">
        <div class="main-inner-screen">
          <RouterView />
          <div :class="callringing ? 'activecallbg' : 'callbg'" @click="" v-if="callnotify">
            <img src="../../../../assets/Img/icons/call.svg" :class="{ shake: callringing }" />
          </div>
          <div class="shortcalldetailbg" v-if="shortcalldetails" @click="showfullcalldetails">
            <div class="d-flex align-items-center gap-2">
              <div class="calltimerbg">
                <!-- <p>{{ overallDetailsData[0]['PendingTime'] }}</p> -->
                <p>{{ formattedTime }}</p>
              </div>
              <p class="patientname">
                {{
                  overallDetailsData[0] &&
                    overallDetailsData[0].contactName &&
                    overallDetailsData[0].contactName.trim() !== ""
                    ? overallDetailsData[0].contactName
                    : "Unknown Number"
                }}
              </p>
            </div>
            <div class="shortnamebg">
              <p>
                {{
                  overallDetailsData.length > 0 &&
                    overallDetailsData[0] &&
                    overallDetailsData[0]["agent_name"]
                    ? overallDetailsData[0]["agent_name"].slice(0, 2)
                    : "GV"
                }}
              </p>
            </div>
          </div>
          <div class="fullcalldetailsdiv" v-if="fullcalldetails">
            <div class="closebg">
              <i class="pi pi-times" @click="closefullcalldetails"></i>
            </div>
            <div class="fullcalldetailsbg">
              <div class="d-flex align-items-center justify-content-between p-3 pb-0">
                <div>
                  <p class="light-txt">VOIP</p>
                  <p class="patientname">
                    {{
                      overallDetailsData[0] &&
                        overallDetailsData[0].contactName &&
                        overallDetailsData[0].contactName.trim() !== ""
                        ? overallDetailsData[0].contactName
                        : "Unknown Number"
                    }}
                  </p>
                  <p class="light-txt">
                    +{{
                      overallDetailsData.length > 0
                        ? overallDetailsData[0]["customer_number"]
                        : ""
                    }}
                  </p>
                </div>
                <div>
                  <div class="calltimerbg">
                    <!-- <p>{{ overallDetailsData[0]['PendingTime'] }}</p> -->
                    <p>{{ formattedTime }}</p>
                  </div>
                  <div class="optionbtnbg float-end mt-3" @click="patientdetails(overallDetailsData[0])">
                    <img src="../../../../assets/Img/icons/idcard.svg" />
                  </div>
                </div>
              </div>
              <div class="transfercalldiv p-2">
                <div v-if="!calltransfer">
                  <span class="p-input-icon-right label-d-none w-100">
                    <i class="pi pi-search" />
                    <TextField v-model="agent.filter" placeholder="Search" name="New Password" label=""
                      :rules="{ required: false }" id="transferlist" :required-icon="false"
                      @update:modelValue="filterAgent(agent.filter)" />
                  </span>
                  <div class="fulltransferlist">
                    <div class="transfercontactdiv" v-for="item in agentList" @click="selectagent(item)">
                      <div class="d-flex align-items-center gap-3">
                        <div class="shortnamebg">
                          <p>{{ item["Name"].slice(0, 2) }}</p>
                        </div>
                        <p>{{ item["Name"] }}</p>
                      </div>
                      <div class="callforwardbg">
                        <img src="../../../../assets/Img/icons/phoneforwarded.svg" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="selectcontactdiv" v-for="item in selectedAgentList" v-if="calltransfer">
                  <div class="d-flex align-items-center gap-3">
                    <div class="shortnamebg">
                      <p>{{ item["Name"] ? item["Name"].slice(0, 2) : "" }}</p>
                    </div>
                    <p>{{ item["Name"] ? item["Name"] : "" }}</p>
                  </div>
                  <i class="pi pi-trash" style="color: #ff5f57" @click="deleteagent"></i>
                </div>
              </div>

              <div class="mt-3 d-flex align-items-center justify-content-around" v-if="selectedAgentList.length > 0">
                <!-- <div class="optionbtnbg" @click="clickToCallOptions('1', overallDetailsData[0])">
                  <img src="../../../../assets/Img/icons/MonitorCall.svg" />
                </div>
                <div class="optionbtnbg" @click="clickToCallOptions('2', overallDetailsData[0])">
                  <img src="../../../../assets/Img/icons/voiceselection.svg" />
                </div>
                <div class="optionbtnbg" @click="clickToCallOptions('3', overallDetailsData[0])">
                  <img src="../../../../assets/Img/icons/BargeCall.svg" />
                </div>
                <div class="optionbtnbg" @click="clickToCallOptions('4', overallDetailsData[0])">
                  <img src="../../../../assets/Img/icons/phoneforwarded.svg" />
                </div>
                <div class="optionbtnbg" @click="clickToCallOptions('5', overallDetailsData[0])">
                  <img src="../../../../assets/Img/icons/phoneforwarded.svg" />
                </div>
                <div class="optionbtnbg" @click="patientdetails(overallDetailsData[0])">
                  <img src="../../../../assets/Img/icons/idcard.svg" />
                </div> -->
                <div v-for="(option, index) in detailsaction" :key="index" :class="{
                  focusoptionbtnbg: activeIndex === index,
                  optionbtnbg: activeIndex !== index,
                }" :title="option.title" @click="option.action(index, overallDetailsData[0])">
                  <img :src="option.imgSrc" />
                </div>
              </div>
              <!-- <div class="my-3 d-flex align-items-center justify-content-around">
                <div class="adddetailsbg">
                  <i class="pi pi-plus"></i>
                  <p>Notes</p>
                </div>
                <div class="adddetailsbg">
                  <i class="pi pi-plus"></i>
                  <p>Task</p>
                </div>
                <div class="adddetailsbg">
                  <i class="pi pi-plus"></i>
                  <p>Whatsapp</p>
                </div>
              </div>
              <div class="shorttask">
                <Textarea name="notes" label="notes" :rules="{ required: false }" id="notes" :rows="3"/>
              </div>
              <div class="d-flex align-items-center justify-content-end me-3">
                <AddButton btnname="Save" class="ps-3"/>
              </div> -->
              <div class="attenderdiv">
                <div class="shortnamebg">
                  <p>
                    {{
                      overallDetailsData.length > 0 &&
                        overallDetailsData[0] &&
                        overallDetailsData[0]["agent_name"]
                        ? overallDetailsData[0]["agent_name"].slice(0, 2)
                        : "GV"
                    }}
                  </p>
                </div>
                <p>
                  {{
                    overallDetailsData.length > 0
                      ? overallDetailsData[0]["agent_name"]
                      : "GV"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="crm-footer-screen">
          <Footer />
        </div>
      </div>
    </div>
  </div>

  <Dialog v-model:visible="VisibleRight" :modal="true" header="Live Calls Table"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '90vw' }" @after-hide="IsClear">
    <b-container>
      <LivecallTableview :liveContactTableList="contactTableList" />
    </b-container>
  </Dialog>

  <Dialog v-model:visible="VisibleRightLogs" :modal="true" header="Call Logs"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '90vw' }"
    @after-hide="IsClear, IsReadUpdate()">
    <b-container>
      <CallTableview @close-dialog="closeDialog" :logstatus="2" :logTableList="missedCallTableList" />
    </b-container>
  </Dialog>

  <Dialog v-model:visible="VisibleNotification" :modal="true" header="WhatsApp"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }" @after-hide="IsClear">
    <div class="details-card" v-for="items in WhatsAppNotifications" @click="RedirectMessage(items)">
      <p class="compo-heading ps-0">{{ items.name }}</p>
      <div class="light-txt">
        <p v-for="i1 in items.msgList">{{ i1 }}</p>
      </div>
    </div>
  </Dialog>

  <!-- Module Switcher Component -->
  <ModuleSwitcher v-model:visible="ModuleSwitcherpopup" :modules="modules" :loading="moduleLoading" :error="moduleError"
    @close="ClearModuleData" />

  <!-- <CallrightsidebarVue :visibleRight="VisibleRight" :isFormdata="{}" @close="closerightsidebar()" /> -->
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  onUnmounted,
  watch,
  onBeforeUnmount,
  computed,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import LivecallTableview from "../../pages/contact/liveCallsTableView.vue";
import CallTableview from "../../pages/contact/callTableview.vue";
import campaignTable from "../../pages/Campaign/campaignTableview.vue";
import LiveCallService from "../../service/liveCallsService";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import Badge from "primevue/badge";
import { onReceiveTaskNotification } from "../../utils/sockets";
import LoginService from "../../service/LoginService";
import SignalRService from "../../utils/signalR";
import WhatsAppCommunicationService from "../../service/whatsAppService";
import LeadService from "../../service/leadService";
import ConatactService from "../../service/contactService";
import TaskTypeService from "../../service/taskType";
import { useForm } from "vee-validate";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import PasswordService from "../../../crm/service/PasswordService";
import todoService from "../../service/siteVisitService";
import MastersService from "../../service/MastersService";
import Footer from "../../../../components/common/ProductFooter.vue";
// import Footer from "../../components/Layout/footer.vue";
import TeleCallService from "../../service/teleCallService";
import AgentService from "../../service/agentService";
import { useToast } from "primevue/usetoast";
import Textarea from "../../../../components/FormComponents/TextArea.vue";
import CommonService from "../../service/commonService";
import ModuleSwitcher from "../../../../components/common/ModuleSwitcher.vue";

export default defineComponent({
  components: {
    CallTableview,
    // CallrightsidebarVue,
    LivecallTableview,
    CustomDropdown,
    TextField,
    UpdatedSuccessfully,
    Footer,
    campaignTable,
    Textarea,
    ModuleSwitcher,
  },
  setup(_, { emit }) {
    debugger;

    const { handleSubmit, errors } = useForm();
    const Changepasswordpopup = ref(false);
    const updatepop = ref(false);
    const mobileoptionvisible = ref(false);

    // Module Switcher functionality
    const ModuleSwitcherpopup = ref(false);
    const signalRService = new SignalRService();
    const selectedItem: any = ref(null);
    const router = useRouter();
    const route = useRoute();
    const visibleLeft = ref(false);
    const VisibleRight = ref(false);
    const VisibleRightLogs = ref(false);
    const contactTableList = ref([] as any[]);
    const callAnsweredList: any = ref([]);
    const overallDetailsData: any = ref([]);
    const callLogTableList = ref([] as any[]);
    const missedCallTableList = ref([] as any[]);
    const sidebarwidth = ref("3rem !important");
    const isFocused = ref(false);
    const leftSidebarRef = ref();
    const VisibleNotification = ref(false);
    const WhatsNotifylen = ref(0);
    const WhatsAppNotifications: any = ref([]);
    let AgentId = ref(0);
    const ContactList = ref([]);
    const LeadList = ref([]);
    let callnotify = ref(true);
    let shortcalldetails = ref(false);
    let fullcalldetails = ref(false);
    let agentList: any = ref([]);
    let copyagentList: any = ref([]);
    let calltransfer = ref(false);
    const toast = useToast();
    let callringing = ref(false);
    let agent = ref({
      filter: "",
    });
    const closeDialog = () => {
      VisibleRightLogs.value = false;
    };
    function closerightsidebar() {
      VisibleRight.value = false;
    }
    function closeLoggs() {
      VisibleRightLogs.value = false;
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let entityData;
    if (SessionEntityData !== null) {
      entityData = JSON.parse(SessionEntityData);
    }
    //

    let OrganizationId = ref();
    let admin = ref();

    const agentdidnumber = ref();
    const userId = ref();
    let BranchId = ref();
    let localstoragedata = ref();
    const notifications = ref([] as any[]);
    let AgentStatus = ref(false);
    let menuarray: any = ref([]);
    let PipeLineType = ref();

    // localstoragedata.value = localStorage.getItem("UsersData");
    // localstoragedata.value = JSON.parse(localstoragedata.value);
    // OrganizationId.value = localstoragedata.value.OrganizationId;
    // userId.value = localstoragedata.value.UserId;
    // BranchId.value = localstoragedata.value.BranchId;
    // agentdidnumber.value = localstoragedata.value.AgentDid;
    // admin.value = localstoragedata.value.Admin;
    // PipeLineType.value = localstoragedata.value.ApplicationType;
    // AgentStatus.value = localstoragedata.value.AgentStatus;
    // AgentId.value = localstoragedata.value.AgentId;

    onMounted(() => {
      debugger;

      if (window.innerWidth < 992) {
        sidebarwidth.value = "0rem";
      } else {
        sidebarwidth.value = "3rem";
      }
      if (menuItems.value.length > 0) {
        selectedItem.value = menuItems.value[0].path;
      }

      // taskList();
      // startConnection();
      // loadTaskNotification();

      ReadyFuntion();
    });

    async function ReadyFuntion() {
      debugger;
      await LoadMenus();
      await whatsAppNotofication();
      await LoadNotification();
      await LoadProfile();
      await LoadProfileBranches();
      await LoadprofileRoles();
      await loadAvailableModules(); // Load modules
    }

    const pipeline = ref([
      { name: "Service Pipeline", value: 1 },
      { name: "Marketing Pipeline", value: 2 },
      { name: "Referal Pipeline", value: 3 },
    ]);

    const SelectedPipeline = ref({
      name:
        usersData.ApplicationType == 1
          ? "Service Pipeline"
          : "Marketing Pipeline",
      value: usersData.ApplicationType,
    });
    function LoadNotification() {
      taskList();
      startConnection();
      startAnswerConnection();
      loadTaskNotification();
    }

    function pipelinerouter() {
      debugger;

      if (usersData) {
        usersData.ApplicationType = Number(SelectedPipeline.value.value);

        localStorage.setItem("UsersData", JSON.stringify(usersData));
      } else {
        console.error("UsersData not found in local storage");
      }

      router.push({
        path: "/newDashboard",
        query: { Pipeline: usersData.ApplicationType },
      });

      // LoadMenus();
      // LoadNotification();
      ReadyFuntion();
    }

    async function LoadMenus() {
      debugger;
      let response = await MastersService.GetMenus(
        4,
        rolesData.RoleId,
        usersData.ApplicationType,
        usersData.OrganizationId
      );

      console.log("LeftBarMenu List", response["result"]);

      menuarray.value = response["result"].sort((a, b) => a.DisplayOrder - b.DisplayOrder);
      //TabClick(menuarray.value[0]);
    }

    async function TabClick(SubMenuDetails) {
      debugger;
      if (SubMenuDetails.FixedHref == "/taskDetails") {
        selectedItem.value = SubMenuDetails.FixedHref;
        router.push({
          path: SubMenuDetails.FixedHref,
          query: { TabValue: "Tab4" },
        });
      } else {
        selectedItem.value = SubMenuDetails.FixedHref;
        router.push({
          path: SubMenuDetails.FixedHref,
        });
      }

      if (window.innerWidth < 992) {
        sidebarwidth.value = "0rem";
      } else {
        sidebarwidth.value = "3rem";
      }
    }

    const screenWidth = ref(window.innerWidth);
    watch(screenWidth, (newWidth) => {
      if (newWidth < 992) {
        // Call your function here
        sidebarwidth.value = "0rem";
      } else {
        sidebarwidth.value = "3rem";
      }
    });

    let timerseconds = 1;
    let intervalSet = false;

    watch(
      () => contactTableList.value,
      (newVal) => {
        debugger;
        if (overallDetailsData.value && overallDetailsData.value.length > 0) {
          if (
            contactTableList.value.every(
              (item) => item.call_id !== overallDetailsData.value[0]["call_id"]
            )
          ) {
            cleardetails();
            stopTimer();
          }
        }
      },
      { deep: true }
    );

    const cleardetails = () => {
      callnotify.value = true;
      callringing.value = false;
      shortcalldetails.value = false;
      fullcalldetails.value = false;
      selectedAgentList.value = [];
    };

    // Update screenWidth when window resizes
    window.addEventListener("resize", () => {
      screenWidth.value = window.innerWidth;
    });

    function OpenSidebar() {
      sidebarwidth.value = sidebarwidth.value === "0" ? "13rem" : "0";
    }

    async function loadTaskNotification() {
      notifications.value = [];
      const result = await TaskTypeService.getList();
    }
    const taskList = async () => {
      try {
        debugger;
        const response = await todoService.getList();
        debugger;
        console.log(response);
      } catch (error) {
        // alert(error);
      }
    };
    const seconds = ref(0);
    let timerId = ref();

    const startAnswerConnection = async () => {
      await signalRService.startConnection();

      signalRService.SendAnsweredCallsNotification((message: any[]) => {
        debugger;
        console.log(message);
        callAnsweredList.value = [];
        callAnsweredList.value.push(...message);
        callAnsweredList.value = callAnsweredList.value.filter(
          (item) => item.clientId == usersData.OrganizationId
        );

        overallDetailsData.value = callAnsweredList.value.filter(
          (item) => item.agentId == usersData.AgentId
        );

        console.log("Full Data1", overallDetailsData.value);

        if (overallDetailsData.value.length == 0) {
          callringing.value = false;
        }

        startTimer();
        showshortcalldetails();
      });
    };

    const startConnection = async () => {
      await signalRService.startConnection();

      signalRService.SendTaskNotification((message: any[]) => {
        debugger;
        notifications.value = [];
        notifications.value.push(...message);
        if (usersData.Admin === 0) {
          notifications.value = notifications.value.filter(
            (item: any) =>
              item.assignAgent === usersData.AgentId &&
              item.pipeLineType == SelectedPipeline.value.value &&
              item.branchId == usersData.BranchId
          );
        } else {
          notifications.value = notifications.value.filter(
            (item) =>
              item.clientId == usersData.OrganizationId &&
              item.pipeLineType == SelectedPipeline.value.value
          );
        }
      });

      signalRService.SendLiveCallsNotification((message: any[]) => {
        debugger;
        contactTableList.value = [];
        contactTableList.value.push(...message);
        contactTableList.value = contactTableList.value.filter(
          (item) => item.clientId == usersData.OrganizationId
        );
        if (contactTableList.value.length > 0) {
          callringing.value = true;
        } else {
          callringing.value = false;
        }
        // alert(contactTableList.value.length)
      });

      signalRService.SendMissedCallsNotification((message: any[]) => {
        missedCallTableList.value = [];
        missedCallTableList.value.push(...message);
        if (usersData.Admin === 0) {
          missedCallTableList.value = missedCallTableList.value.filter(
            (item: any) => item.did === usersData.AgentDid
          );
        } else {
          missedCallTableList.value = missedCallTableList.value; //.filter((item) => item.ClientId == usersData.OrganizationId);
        }
        let count = 1;
        if (count == 1) {
          let count = 0;
          Object.values(missedCallTableList.value).forEach((items: any) => {
            count = count + 1;
            items.rownumber = count;
          });
        }
      });

      signalRService.SendWhatsappNotification((message: any[]) => {
        WhatsAppNotifications.value = [];
        WhatsAppNotifications.value.push(...message);
        if (usersData.Admin === 0) {
          WhatsAppNotifications.value = WhatsAppNotifications.value.filter(
            (item: any) =>
              item.agentId == usersData.AgentId &&
              item.clientId == usersData.OrganizationId
          );
        } else {
          WhatsAppNotifications.value = WhatsAppNotifications.value.filter(
            (item) => item.clientId == usersData.OrganizationId
          );
        }
      });
    };

    const intervalID = ref<NodeJS.Timeout | null>(null);
    const timerSeconds = ref(0);
    const isTimerRunning = ref(false);

    // Computed property for formatted time
    const formattedTime = computed(() => {
      return new Date(timerSeconds.value * 1000).toISOString().substr(11, 8);
    });

    // Function to start the timer
    const startTimer = () => {
      if (!isTimerRunning.value) {
        console.log("Setting interval and starting timer from 0");
        timerSeconds.value = 0;
        isTimerRunning.value = true;

        // Update function
        const updateTimer = () => {
          timerSeconds.value++;
        };

        // Start interval
        intervalID.value = setInterval(updateTimer, 1000);
      }
    };

    // Function to stop the timer
    const stopTimer = () => {
      if (isTimerRunning.value && intervalID.value) {
        console.log("Clearing interval");
        clearInterval(intervalID.value);
        isTimerRunning.value = false;
      }
    };

    onUnmounted(() => {
      stopConnection();
    });

    const stopConnection = async () => {
      await signalRService.stopConnection();
    };

    const menu = ref();
    let name = ref("");
    const items = ref([{ separator: true }]);
    const toggle = (event) => {
      debugger;
      menu.value.toggle(event);
    };

    const handleClickOutside = (event) => {
      debugger;
      if (window.innerWidth < 992) {
        sidebarwidth.value = "0rem";
      } else {
        sidebarwidth.value = "3rem";
      }
      mobileoptionvisible.value = false;
    };

    // async function LogOut() {
    //   debugger;

    //   if (usersData.ApplicationType == 2 && usersData.AgentId != 0) {
    //     const ObjValue = ref({
    //       AgentID: usersData.AgentId,
    //       status: 2,
    //     });

    //     const DataResponse = await TeleCallService.AgentBlockAndUnblock(
    //       ObjValue.value
    //     );
    //   }

    //   localStorage.clear();
    //   router.push({
    //     path: "/login",
    //   });
    // }

    async function LogOut() {
      debugger;
      if (usersData.ApplicationType == 2 && usersData.AgentId != 0) {
        const ObjValue = ref({
          AgentID: usersData.AgentId,
          status: 2,
        });

        const DataResponse = await TeleCallService.AgentBlockAndUnblock(
          ObjValue.value
        );
      }
      // Check if we came from MOPUI (cross-app navigation)
      const sourceApp = localStorage.getItem('SourceApp');
      const crossAppNavigation = localStorage.getItem('CrossAppNavigation');

      // Clear MoceroUI localStorage first
      localStorage.clear();

      if (sourceApp === 'MOPUI' && crossAppNavigation === 'true') {
        // Try to navigate back to MOPUI login with logout parameter
        try {
          const mopuiUrl = window.location.port === '5174' ? 'http://localhost:5173' : window.location.origin;
          // Add logout parameter to signal MOPUI to clear its localStorage
          window.location.href = `${mopuiUrl}/auth/login?logout=true&source=MoceroUI`;
        } catch (error) {
          console.error('Failed to navigate to MOPUI login, using standalone login:', error);
          router.push({ path: "/login" });
        }
      } else {
        // Use standalone MoceroUI login
        router.push({ path: "/login" });
      }
    }

    const menuItems = ref([
      {
        label: "Dashboard",
        icon: "/src/assets/Img/icons/crmdashboard.svg",
        path: "/dashboard",
      },
      {
        label: "Contacts",
        icon: "/src/assets/Img/icons/contactimg.svg",
        path: "/contacttableview",
      },
      {
        label: "My Tasks",
        icon: "/src/assets/Img/icons/mytask.svg",
        path: "/taskDetails",
      },
      {
        label: "Masters",
        icon: "/src/assets/Img/icons/master.svg",
        path: "/masters",
      },
      {
        label: "Reports",
        icon: "/src/assets/Img/icons/reportimg.svg",
        path: "/reports",
      },
    ]);

    let ProfileData = ref({
      UserNameFirstLetter: "",
      UserName: "",
      RoleName: "",
      phoneNumber: "",
    });

    function LoadProfile() {
      debugger;
      ProfileData.value.UserNameFirstLetter = usersData.UserName.charAt(0);
      ProfileData.value.UserName = usersData.UserName;
      ProfileData.value.RoleName = rolesData.RoleName;
      ProfileData.value.phoneNumber = usersData.phoneNumber;
    }

    let SelectedBranchId = ref();

    let BranchDropDown: any = ref({
      BranchOption: [],
    });

    let SelectedRoleId = ref();
    let RoleDropDown: any = ref({
      RoleOption: [],
    });

    let BranchDropDownLength = ref();
    let RoleDropDownLength = ref();

    async function LoadProfileBranches() {
      debugger;
      const data_response = await LoginService.GetBranchesByUserId(
        usersData.UserId
      );
      console.log(data_response["result"]);

      BranchDropDown.value.BranchOption = data_response["result"].map(
        (item) => ({
          BranchName: item.BranchName,
          BranchId: item.BranchId,
          HospitalBranchId: item.HospitalBranchId,
          HospitalBranchCode: item.HospitalBranchCode,
        })
      );

      BranchDropDownLength.value = data_response["result"].length;

      if (BranchDropDownLength.value == 1) {
        SelectedBranchId.value = {
          BranchName: data_response["result"][0].BranchName,
          BranchId: data_response["result"][0].BranchId,
          HospitalBranchId: data_response["result"][0].HospitalBranchId,
          HospitalBranchCode: data_response["result"][0].HospitalBranchCode,
        };
      } else {
        let BranchValue = BranchDropDown.value.BranchOption.filter(
          (x) => x.BranchId == usersData.BranchId
        );

        SelectedBranchId.value = {
          BranchName: BranchValue[0].BranchName,
          BranchId: BranchValue[0].BranchId,
          HospitalBranchId: BranchValue[0].HospitalBranchId,
          HospitalBranchCode: BranchValue[0].HospitalBranchCode,
        };
      }
    }

    function BranchOnChange(data) {
      debugger;
      usersData.BranchId = SelectedBranchId.value.BranchId;
      usersData.HospitalBranchId = SelectedBranchId.value.HospitalBranchId;
      usersData.HospitalBranchCode = SelectedBranchId.value.HospitalBranchCode;
      localStorage.setItem("UsersData", JSON.stringify(usersData));
      router.push({
        path: "/Masters",
      });
      window.location.reload();
    }

    async function LoadprofileRoles() {
      debugger;
      const data_response = await LoginService.GetRolesByUserId(
        usersData.UserId,
        //SelectedBranchId.value.BranchId
        0
      );
      console.log(data_response["result"]);
      RoleDropDown.value.RoleOption = data_response["result"].map((item) => ({
        RoleName: item.RoleName,
        RoleId: item.RoleId,
        DeptRoleMapId: item.DeptRoleMapId,
      }));

      RoleDropDownLength.value = data_response["result"].length;

      if (RoleDropDownLength.value == 1) {
        SelectedRoleId.value = {
          RoleName: data_response["result"][0].RoleName,
          RoleId: data_response["result"][0].RoleId,
          DeptRoleMapId: data_response["result"][0].DeptRoleMapId,
        };
        RoleOnchange();
      } else {
        let RoleValue = RoleDropDown.value.RoleOption.filter(
          (x) => x.RoleId == rolesData.RoleId
        );

        SelectedRoleId.value = {
          RoleName: RoleValue[0].RoleName,
          RoleId: RoleValue[0].RoleId,
          DeptRoleMapId: RoleValue[0].DeptRoleMapId,
        };
      }
    }

    async function RoleOnchange() {
      debugger;
      console.log("Selected RoleId:", SelectedRoleId.value.RoleId);
      localStorage.removeItem("RolesData");
      let RolesData = {
        RoleId: SelectedRoleId.value.RoleId,
        RoleName: SelectedRoleId.value.RoleName,
        DeptRoleMapId: SelectedRoleId.value.DeptRoleMapId,
      };
      localStorage.setItem("RolesData", JSON.stringify(RolesData));

      ProfileData.value.RoleName = SelectedRoleId.value.RoleName;

      // let existingUsersData = localStorage.getItem("UsersData");
      // let usersData;
      // if (existingUsersData !== null) {
      //   usersData = JSON.parse(existingUsersData);
      // }
      // usersData.BranchId = SelectedBranchId.value.BranchId;
      // localStorage.setItem("UsersData", JSON.stringify(usersData));

      if (RoleDropDownLength.value > 1) {
        router.push({
          path: "/Masters",
        });
        window.location.reload();
      }
    }

    function navigate(path) {
      debugger;
      visibleLeft.value = false;
      router.push(path);
      selectedItem.value = path;
      sidebarOpen.value = false;
      if (window.innerWidth < 992) {
        sidebarwidth.value = "0rem !important";
      } else {
        sidebarwidth.value = "3rem !important";
      }
    }

    const callid = ref();

    function closesidebar() {
      visibleLeft.value = false;
    }

    const IsClear = () => {
      emit("update:selectedItem", undefined);
      emit("close");
    };

    const isHovered = ref(false);
    let sidebarOpen = ref(true);

    function hoverHandler(isHovering) {
      if (isHovering) {
        sidebarwidth.value = sidebarOpen
          ? "13rem !important"
          : "3rem !important";
      } else {
        sidebarwidth.value = "3rem !important";
      }
    }

    const clickOutsideHandler = (event: MouseEvent) => { };
    let updateloglist: { value: Updateloglist[] } = ref([]);
    type Updateloglist = {
      CreatedAt: "2023-07-14T11:39:27.294Z";
      ModifiedAt: "2023-07-14T11:39:27.294Z";
      CreatedBy: Number;
      ModifiedBy: Number;
      CreatedByName: String;
      BranchId: Number;
      id: Number;
      user_id: Number;
      client_id: String;
      clientId: Number;
      moceroClientId: Number;
      call_id: String;
      direction: Number;
      source: String;
      type: String;
      did: String;
      multiple_destination_type: String;
      multiple_destination_name: String;
      destination: String;
      state: String;
      queue_state: String;
      channel_id: String;
      created_at: String;
      sip_domain: String;
      broadcast_id: String;
      broadcast_no: String;
      call_time: String;
      agent_name: String;
      customer_number: String;
      callStatus: Number;
      isRead: Number;
      readBy: String;
    };

    async function IsReadUpdate() {
      // loading.value = true;
      debugger;
      try {
        for (let i = 0; i < missedCallTableList.value.length; i++) {
          updateloglist.value.push({
            CreatedAt: "2023-07-14T11:39:27.294Z",
            ModifiedAt: "2023-07-14T11:39:27.294Z",
            CreatedBy: 0,

            ModifiedBy: 0,
            CreatedByName: "string",
            BranchId: 0,
            id: missedCallTableList.value[i]["id"],
            user_id: 0,
            client_id: "string",
            clientId: localstoragedata.value.OrganizationId,
            moceroClientId: 0,
            call_id: missedCallTableList.value[i]["call_id"],
            direction: 0,
            source: "string",
            type: "string",
            did: "string",
            multiple_destination_type: "string",
            multiple_destination_name: "string",
            destination: "string",
            state: "string",
            queue_state: "string",
            channel_id: "string",
            created_at: "string",
            sip_domain: "string",
            broadcast_id: "string",
            broadcast_no: "string",
            call_time: "string",
            agent_name: "string",
            customer_number: "string",
            callStatus: 0,
            isRead: 1,
            readBy: localstoragedata.value.UserId,
          });
        }

        for (let index = 0; index < updateloglist.value.length; index++) {
          const result = await LiveCallService.updatethelog(
            updateloglist.value[index]
          );
        }

        // loading.value = false;
      } catch (error) {
        // loading.value = false;
      }
    }
    //Contact List
    async function LoadContactList() {
      debugger;
      try {
        const result = await ConatactService.getList();
        console.log(result);
        result["result"] = result["result"]
          .filter((item) => item.ClientId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });
        ContactList.value = result["result"];
      } catch (error) { }
    }

    //Lead List
    async function LoadLeadList() {
      debugger;
      try {
        const result = await LeadService.getList();
        console.log(result);
        result["result"] = result["result"]
          .filter(
            (item) =>
              item.ClientId == usersData.OrganizationId &&
              item.AssignTo == usersData.AgentId
          )
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });
        LeadList.value = result["result"];
      } catch (error) { }
    }

    //WhatsApp Notification list
    async function whatsAppNotofication() {
      try {
        debugger;
        const result = await WhatsAppCommunicationService.getList();
        // let watcount = 0;
        // result["result"] = result["result"].filter(
        //   (item) => item.SenderID != 0 && item.IsRead == 0
        // );
        // let arrCon: any = result["result"].filter(
        //   (item) => item.ContactID != 0
        // );
        // let ContactDet = arrCon.reduce((uniqueArr, item) => {
        //   if (!uniqueArr.some((obj) => obj.CommonId === item.ContactID)) {
        //     let MsgList = result["result"]
        //       .filter((items) => items.ContactID == item.ContactID)
        //       .map((i1) => i1.MessageText);
        //     let Contacts: any = ContactList.value.find(
        //       (item1: any) => item1.Id == item.ContactID
        //     );
        //     watcount = watcount + MsgList.length;
        //     uniqueArr.push({
        //       CommonId: item.ContactID,
        //       Type: 0,
        //       MsgList: MsgList,
        //       Name: Contacts.Fullname,
        //     });
        //   }
        //   return uniqueArr;
        // }, []);
        // let arrLead: any = result["result"].filter((item) => item.LeadID != 0);
        // let LeadDet = arrLead.reduce((uniqueArr, item) => {
        //   if (!uniqueArr.some((obj) => obj.CommonId === item.LeadID)) {
        //     let MsgList = result["result"]
        //       .filter((items) => items.LeadID == item.LeadID)
        //       .map((i1) => i1.MessageText);
        //     let Leads: any = LeadList.value.find(
        //       (item1: any) => item1.Id == item.LeadID
        //     );
        //     watcount = watcount + MsgList.length;
        //     uniqueArr.push({
        //       CommonId: item.LeadID,
        //       Type: 1,
        //       MsgList: MsgList,
        //       Name: Leads.Fullname,
        //     });
        //   }
        //   return uniqueArr;
        // }, []);

        // WhatsAppNotifications.value = [...ContactDet, ...LeadDet];
        // WhatsNotifylen.value = watcount;
      } catch (error) { }
    }

    //Redirect To WhatsApp page
    function RedirectMessage(item) {
      VisibleNotification.value = false;
      router.push({
        path: "/contactDetail",
        query: {
          ID: item.commonId,
          Type: item.type,
          Index: "whatsapp",
        },
      });
    }

    function mopcrm() {
      visibleLeft.value = true;
      router.push({
        path: "/dashboard",
      });
    }

    let ChangePasswordObjVal = ref({
      newpassword: "",
      confirmpassword: "",
    });

    let UserChangePasswordObjVal = ref({
      UserId: 0,
      Password: "",
    });

    const copyupdatepassword = JSON.parse(
      JSON.stringify(ChangePasswordObjVal.value)
    );

    const showError = ref(false);
    const IsStoreSubmit = handleSubmit(async (values) => {
      debugger;
      if (
        ChangePasswordObjVal.value.confirmpassword !==
        ChangePasswordObjVal.value.newpassword
      ) {
        showError.value = true;
      } else {
        showError.value = false;

        UserChangePasswordObjVal.value.UserId = usersData.UserId;

        UserChangePasswordObjVal.value.Password =
          ChangePasswordObjVal.value.confirmpassword;

        let response = await PasswordService.ChangePassword(
          UserChangePasswordObjVal.value
        );
        console.log(response["result"]);

        let msg = response["ErrorInfo"].ErrorCode;

        if (msg == null) {
          updatepop.value = true;
        } else {
          alert("Somthing went wrong");
        }
      }
    });

    function closetrigger() {
      updatepop.value = false;
      LogOut();
    }

    let showpass = ref(true);
    let showconfpass = ref(true);
    let showtxt = ref("Password");
    let showConfirmtxt = ref("Password");
    function showhide() {
      if (showpass.value == true) {
        showpass.value = false;
        showtxt.value = "text";
      } else {
        showpass.value = true;
        showtxt.value = "Password";
      }
    }

    function confirmshowhide() {
      debugger;
      if (showconfpass.value == true) {
        showconfpass.value = false;
        showConfirmtxt.value = "text";
      } else {
        showconfpass.value = true;
        showConfirmtxt.value = "Password";
      }
    }

    function mobileoptiontoggle() {
      mobileoptionvisible.value = !mobileoptionvisible.value;
    }

    const showshortcalldetails = () => {
      debugger;
      if (
        overallDetailsData.value.length > 0 &&
        overallDetailsData.value[0] &&
        usersData.AgentId == overallDetailsData.value[0]["agentId"]
      ) {
        callnotify.value = false;
        shortcalldetails.value = true;
        loadagentList();
      } else {
        callnotify.value = true;
        callringing.value = false;
        shortcalldetails.value = false;
        fullcalldetails.value = false;
        stopTimer();
        selectedAgentList.value = [];
      }
    };

    const showfullcalldetails = () => {
      debugger;

      if (usersData.AgentId == overallDetailsData.value[0]["agentId"]) {
        debugger;
        shortcalldetails.value = false;
        fullcalldetails.value = true;
        calltransfer.value = false;
      }
    };

    const closefullcalldetails = () => {
      fullcalldetails.value = false;
      shortcalldetails.value = true;
    };

    async function loadagentList() {
      debugger;
      try {
        const result = await AgentService.AgentListWithBranch(
          usersData.OrganizationId
        );
        console.log("Agent List", result["result"]);

        result["result"] = result["result"].filter(
          (i1) =>
            i1.ClientId == usersData.OrganizationId &&
            // i1.Id != props.isFormdata.AssignTo
            i1.Id != usersData.AgentId
        );

        agentList.value = result["result"];
        copyagentList.value = agentList.value;
        console.log(agentList.value);
      } catch (error) {
        alert(error);
      }
    }

    const filterAgent = (data) => {
      debugger;
      agentList.value = copyagentList.value.filter((agent) => {
        return agent.Name.toLowerCase().includes(data); // Case insensitive check
      });
    };

    let selectedAgentList: any = ref([]);
    let ObjInterComOrMobileNumber = ref({
      InterComNumber: "",
      MobileNumber: "",
    });

    let SelectedagentId = ref(0);

    const selectagent = (data) => {
      selectedAgentList.value = [];
      selectedAgentList.value.push(data);
      SelectedagentId.value = data.TTAgentId;
      if (data) {
        ObjInterComOrMobileNumber.value.InterComNumber = data["Intercom"];
        ObjInterComOrMobileNumber.value.MobileNumber = data["FollowmeNumber"];
      }
      calltransfer.value = true;
    };

    const deleteagent = () => {
      selectedAgentList.value = [];
      calltransfer.value = false;
      ObjInterComOrMobileNumber.value.InterComNumber = "";
      ObjInterComOrMobileNumber.value.MobileNumber = "";
    };

    const transfercall = () => {
      calltransfer.value = true;
    };

    const patientdetails = (data) => {
      debugger;
      router.push({
        path: "contactDetail",
        query: {
          ID: data.contactId,
          Type: 0,
        },
      });
    };

    const clickToCallOptions = async (Type: String, index, data) => {
      debugger;
      activeIndex.value = index;
      let InterComOrMobileNumber = "";

      if (Type == "4") {
        InterComOrMobileNumber =
          ObjInterComOrMobileNumber.value.InterComNumber.toString();
      } else if (Type == "5") {
        InterComOrMobileNumber =
          ObjInterComOrMobileNumber.value.InterComNumber.toString();
      } else {
        InterComOrMobileNumber = "0";
      }

      let isCallform = ref({
        agentID: 0,
        clientNumber: 0,
        type: Type,
        call_id: data.call_id,
        agent_id: SelectedagentId.value,
        intercom: InterComOrMobileNumber,
      });

      try {
        if (SelectedagentId.value != null) {
          const response = await TeleCallService.clicktoCallOptions(
            isCallform.value
          );
          let data = response["result"];
        } else {
          toast.add({
            severity: "warn",
            summary: "Please select the agent",
            detail: "Agent",
            life: 3000,
          });
        }
      } catch (error) {
        alert(error);
      }
    };
    const activeIndex = ref(-1);

    const detailsaction = [
      {
        imgSrc: "/src/assets/Img/icons/MonitorCall.svg",
        action: clickToCallOptions.bind(null, "1"),
        title: "Monitor Call",
      },
      {
        imgSrc: "/src/assets/Img/icons/voiceselection.svg",
        action: clickToCallOptions.bind(null, "2"),
        title: "Whisper call",
      },
      {
        imgSrc: "/src/assets/Img/icons/BargeCall.svg",
        action: clickToCallOptions.bind(null, "3"),
        title: "Barge",
      },
      {
        imgSrc: "/src/assets/Img/icons/phoneforwarded.svg",
        action: clickToCallOptions.bind(null, "4"),
        title: "Transfer call by Mobile",
      },
      {
        imgSrc: "/src/assets/Img/icons/intercomtransfer.svg",
        action: clickToCallOptions.bind(null, "5"),
        title: "Transfer call by Intercom",
      },
    ];

    // const seconds = ref(0);
    let interval: ReturnType<typeof setInterval> | null = null;

    // const startTimer = () => {
    //   if (interval) return; // Prevent multiple intervals
    //   interval = setInterval(() => {
    //     seconds.value++;
    //   }, 1000);

    // };

    const formatTime = () => {
      const hours = Math.floor(seconds.value / 3600);
      const minutes = Math.floor((seconds.value % 3600) / 60);
      const remainingSeconds = seconds.value % 60;

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
    };

    const CallLog = () => {
      router.push({
        path: "callLog",

      });
    }

    // Module loading state
    const modules = ref<any[]>([]);
    const moduleLoading = ref(false);
    const moduleError = ref<string | undefined>(undefined);

    // Load available modules
    async function loadAvailableModules() {
      try {
        moduleLoading.value = true;
        moduleError.value = undefined;

        const response: any = await CommonService.GetModulesByOrganizationId(usersData.OrganizationId);

        if (response && response.result) {
          // Map the API response to include proper icons, colors, and types
          modules.value = response.result.map((module: any) => ({
            ...module,
            icon: getModuleIcon(module.ModuleName),
            color: getModuleColor(module.ModuleName),
            type: getModuleType(module.ModuleName)
          }));
        }
      } catch (error) {
        console.error('Error loading modules:', error);
        moduleError.value = 'Failed to load modules';
      } finally {
        moduleLoading.value = false;
      }
    }

    // Helper functions for module display
    function getModuleIcon(moduleName: string): string {
      const iconMap: { [key: string]: string } = {
        'Inventory': 'pi pi-box',
        'CRM': 'pi pi-users',
        'Billing': 'pi pi-money-bill',
        'User Management': 'pi pi-user-edit',
        'Communication': 'pi pi-comments',
        'Alert Engine': 'pi pi-bell'
      };
      return iconMap[moduleName] || 'pi pi-th-large';
    }

    function getModuleColor(moduleName: string): string {
      const colorMap: { [key: string]: string } = {
        'Inventory': '#4CAF50',
        'CRM': '#2196F3',
        'Billing': '#FF9800',
        'User Management': '#9C27B0',
        'Communication': '#00BCD4',
        'Alert Engine': '#F44336'
      };
      return colorMap[moduleName] || '#607D8B';
    }

    function getModuleType(moduleName: string): string {
      // Determine if module belongs to MOPUI or MoceroUI
      const moceroUIModules = ['Inventory', 'CRM', 'Billing', 'User Management', 'Communication', 'Alert Engine'];
      return moceroUIModules.includes(moduleName) ? 'MoceroUI' : 'MOPUI';
    }

    // Clear module data when dialog closes
    function ClearModuleData() {
      // Reset any temporary data if needed
    }

    return {
      mopcrm,
      missedCallTableList,
      closeLoggs,
      contactTableList,
      callLogTableList,
      IsClear,
      LogOut,
      VisibleRightLogs,
      VisibleRight,
      closerightsidebar,
      menuItems,
      navigate,
      closesidebar,
      visibleLeft,
      sidebarwidth,
      isHovered,
      hoverHandler,
      selectedItem,
      SelectedPipeline,
      pipeline,
      handleClickOutside,
      notifications,
      items,
      toggle,
      menu,
      callid,
      ProfileData,
      SelectedRoleId,
      RoleDropDown,
      RoleOnchange,
      RoleDropDownLength,
      onReceiveTaskNotification,
      IsReadUpdate,
      signalRService,
      startConnection,
      stopConnection,
      userId,
      VisibleNotification,
      WhatsNotifylen,
      WhatsAppNotifications,
      RedirectMessage,
      loadTaskNotification,
      BranchDropDownLength,
      SelectedBranchId,
      BranchDropDown,
      BranchOnChange,
      closeDialog,
      Changepasswordpopup,
      IsStoreSubmit,
      showpass,
      showconfpass,
      showtxt,
      showConfirmtxt,
      showhide,
      confirmshowhide,
      ChangePasswordObjVal,
      showError,
      updatepop,
      closetrigger,
      OpenSidebar,
      mobileoptionvisible,
      mobileoptiontoggle,
      AgentStatus,
      AgentId,
      menuarray,
      TabClick,
      rolesData,
      pipelinerouter,
      shortcalldetails,
      showshortcalldetails,
      fullcalldetails,
      callnotify,
      showfullcalldetails,
      agentList,
      closefullcalldetails,
      agent,
      filterAgent,
      calltransfer,
      transfercall,
      patientdetails,
      clickToCallOptions,
      selectagent,
      deleteagent,
      selectedAgentList,
      overallDetailsData,
      seconds,
      formatTime,
      detailsaction,
      activeIndex,
      callAnsweredList,
      callringing,
      timerseconds,
      formattedTime,
      isTimerRunning,
      CallLog,
      // Router
      router,
      // Module Switcher
      ModuleSwitcherpopup,
      modules,
      moduleLoading,
      moduleError,
      loadAvailableModules,
      ClearModuleData
    };
  },
});
</script>

<style lang="scss">
@import "../../../../assets/variables.scss";

//Header-Styles
.crmheader.navbar-header .navbar {
  background-color: $CRMHeaderBg !important;
}

.header-images {
  filter: $HeaderImages !important;
}

.hamburger .pi {
  color: $Hamburger;
}

.leftsidebarbg {
  background-color: $HeaderSidebarBg !important;
  transition: width 0.3s ease;
}

.mobiletoggle .header-images {
  filter: $HeaderMenuImages !important;
}

.crmlogobg {
  background-color: $HeaderLogoBg;
}

.sidebarmenu img {
  filter: $HeaderImages;
}

//Header-Styles

.mobiletoggle img {
  width: 28px;
}

.crmheading {
  font-size: 12px;
  color: $CrmHeading;
  margin: auto 12px;
}

.hamburger .pi {
  font-size: 23px;
  padding: 12px 12px;
}

.appsicon {
  display: none;
}

.mobiletoggle {
  position: absolute;
  background-color: #fff;
  z-index: 999;
  padding: 7px;
  right: 8%;
  border-radius: 5px;
  top: 81%;
  width: 150px;
}

.mobiletoggle div {
  padding: 3px 0;
}

.mobiletoggle p {
  font-size: 14px;
}

.mobiletoggle .p-badge {
  background: $NotificationBadgeBg !important;
  color: $NotificationBadgeColor !important;
  font-size: 0.7rem;
  font-weight: 700;
  min-width: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  padding: 0 !important;
}

.mobilelivecalls .p-badge {
  height: 1rem !important;
  font-size: 0.6rem !important;
  line-height: 0.5rem !important;
  padding: 0.25rem !important;
  min-width: 1rem !important;
}

.s-list {
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 5px !important;
}

.p-sidebar-header {
  justify-content: flex-start !important;
}

.p-sidebar-header .p-sidebar-icon.p-link {
  display: none;
}

.p-sidebar-icon {
  color: #ffffff !important;
}

.p-sidebar-icon:focus {
  color: #ffffff !important;
  box-shadow: none !important;
}

.p-sidebar-icon:enabled:hover {
  color: #ffffff !important;
  background: #000000 !important;
}

.crmlogobg .icon-size {
  border-radius: 50%;
  width: 43px;
}

.bg-info {
  --bs-info-rgb: 0, 0, 0 !important;
}

.beforeselected .list-icon {
  filter: $BeforeSelectedImg;
  width: 20px;
  height: 20px;
  margin-right: 0px !important;
}

.menuhead {
  border-radius: 6px 6px 0 0;
}

.menu-heading1 {
  font-size: 17px;
  font-weight: 600;
}

.localedropdown .p-dropdown {
  width: 100%;
  background: #000000 !important;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 6px;
  height: 37px;
  margin-top: 6px;
}

.localedropdown {
  margin-right: 10px;
}

.p-menu {
  padding: 0 0 !important;
}

.p-menu .p-menuitem-separator {
  margin: 0 0 !important;
}

.header-static {
  position: sticky !important;
  top: 0;
  left: 0;
  z-index: 100;
}

.profile {
  cursor: pointer;
}

.localedropdown {
  text-transform: capitalize;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  text-transform: capitalize;
}

.p-sidebar-left .p-sidebar {
  width: 12rem !important;
}

.p-sidebar-header .pi {
  font-size: 16px !important;
}

.s-list span {
  padding-left: 10px;
}

.s-list-menu span {
  padding-left: 10px;
}

.s-list-menu .btn-content {
  width: 100%;
  color: white;
  cursor: pointer;
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 5px;
}

.sidebar-list .p-button {
  background: none;
  border: none;
  padding: 0rem 0rem;
  font-size: 14px;
  width: 100%;
}

.sidebar-list .p-button:enabled:hover {
  background: none;
  border: none;
}

.sidebar-list .p-button-label {
  font-weight: 400;
}

.s-list span,
.s-list-menu span {
  font-size: 14px;
  color: #ffffff;
}

.s-list .pi,
.s-list-menu .pi {
  font-size: 14px;
  color: #ffffff;
}

.s-list-menu #collapse-1 {
  padding: 0px 0px 0px 10px;
}

.s-list-menu #collapse-1-inner,
.s-list-menu #collapse-2-inner,
.s-list-menu #collapse-3-inner {
  padding: 0px 0px 0px 15px;
}

.s-list-menu li span {
  color: #e1e1e1;
  padding: 8px 0px 8px 15px;
}

.s-list-menu .collapsed .pi {
  transform: rotate(180deg);
}

.collapse ul li {
  cursor: pointer;
}

.mobilelivecalls .livecallsbg {
  display: none;
}

.livecallsbg {
  color: $LiveVCallColor;
  align-self: center;
  cursor: pointer;
  background-color: $LiveVCallBg;
  border-radius: 25px;
  display: flex;
  padding: 3px 10px !important;
  font-size: 12px;
}

.livecallsbg .p-badge.p-badge-warning {
  background-color: $LiveVCallBadgeBg !important;
  color: $LiveVCallBadgeColor !important;
  min-width: 0.25rem;
  height: 1rem;
  line-height: 1.6em;
  font-size: 10px;
}

.call-count {
  position: absolute;
  bottom: 15px;
  left: 6px;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // padding: 3px;
  border-radius: 100%;
  background-color: red;
  font-size: 9px;
}

.leftsidebarbg {
  height: 100vh;
  position: fixed;
  overflow: hidden;
  z-index: 100;
}

.crm-router-screen {
  height: calc(100vh - 47px);
  margin-left: auto;
  overflow: auto;
}

.crm-router-screen {
  width: 96.5%;
  margin-left: auto;
}

.main-inner-screen {
  height: calc(100vh - 95px); // padding: 15px;
  padding-bottom: 30px;
  overflow: auto;
  position: relative;
}

.selected {
  background-color: $SelectedBg;
  border-radius: 50%;
  display: flex;
}

.selected .list-icon {
  filter: $SelectedImg !important;
}

.beforeselected {
  padding: 7px 7px;
}

.selectedcontent {
  background-color: $SelectedBg;
  color: $SelectedColor !important;
  padding: 6px;
  width: 140px;
  border-radius: 5px;
  // border-top-left-radius:50px;
  // border-bottom-left-radius:50px;
}

.menucontent {
  font-size: 12px;
  margin-left: 11px;
  color: $BeforeSelectedColor;
}

.pipelinedropdown {
  font-size: 12px;
  margin-left: 15px;
}

.pipelinedropdown .p-dropdown {
  width: 140px !important;
  background-color: #ffffff;
  color: #ffffff;
  font-size: 10px;
  margin-top: 3px;
}

.pipelinedropdown .p-inputtext {
  font-size: 12px;
  background: #ffffff !important;
  padding: 0.7rem 0.5rem 0.5rem;
  border-radius: 0px;
}

.pipelinedropdown .p-dropdown .p-dropdown-trigger {
  background: white;
  width: 23px;
  margin-top: 5px;
}

.pipelinedropdown .pi {
  font-size: 0.7rem;
}

.header-static .container-fluid {
  padding-left: 0;
}

.profileimg {
  border-radius: 50%;
  width: 30px;
}

.crmsettings {
  cursor: pointer;
  padding: 10px 0;
  display: flex;
  position: relative;
}

.crmsettings .pi {
  color: #999999;
  font-size: 1.25rem;
}

.mobiletoggle .callicon-badge {
  position: absolute;
  top: 1%;
  left: 13%;
}

.mobiletoggle .notification-number-badge {
  position: absolute;
  top: 37%;
  left: 13%;
}

.mobiletoggle .whatsappicon-badge {
  position: absolute;
  top: 1%;
  left: 46%;
}

.callicon-badge {
  position: absolute;
  top: 1%;
  left: 5%;
}

.notification-number-badge {
  position: absolute;
  top: 1%;
  left: 48%;
}

.whatsappicon-badge {
  position: absolute;
  top: 1.8%;
  left: 28%;
}

.notification-badge .p-badge {
  background: $NotificationBadgeBg !important;
  color: $NotificationBadgeColor !important;
  font-size: 0.7rem;
  font-weight: 500;
  min-width: 0.9rem;
  height: 0.9rem;
  line-height: 0.9rem;
}

// .blink span {
//   animation: blink 1s linear infinite;
// }

// @keyframes blink {
//   0% {
//     opacity: 0;
//   }

//   50% {
//     opacity: 0.5;
//   }

//   100% {
//     opacity: 1;
//   }
// }

.header-icons {
  width: 25px;
}

.header-images {
  width: 20px !important;
  margin: 0 10px;
}

.mobiletoggle .header-images {
  width: 16px !important;
  margin: 0 14px 0 5px;
}

.pwd-icon {
  position: absolute;
  right: 15px;
  top: 35px;
}

.crmprofilemenu {
  width: 250px !important;
}

// @media only screen and (max-width: 1400px) {
//   // .main-inner-screen {
//   //   height: 87.5vh !important;
//   // }
// }

@media only screen and (min-width: 1400px) {
  // .main-inner-screen {
  //   height: 90.5vh !important;
  //   // display: flex;
  //   // justify-content: center;
  // }

  .crmprofilemenu {
    // left:1185px;
    top: 45px;
    width: 15rem;
  }
}

@media only screen and (min-width: 1500px) {
  .crm-router-screen {
    width: 97.4%;
    margin-left: auto;
  }
}

@media only screen and (max-width: 991px) {
  .crmlogobg {
    background: none;
  }

  .crm-router-screen {
    width: 100%;
    margin-left: 0;
  }

  .crmprofilemenu {
    // left:1270px;
    top: 45px;
    width: 15rem;
  }
}

@media only screen and (max-width: 768px) {
  .appsicon {
    display: block;
  }

  .crmsettings {
    display: none !important;
  }

  .mobiletoggle .notification-number-badge {
    left: 14%;
    top: 47%;
  }

  .mobiletoggle .whatsappicon-badge {
    left: 14%;
    top: 27%;
  }

  .mobiletoggle .callicon-badge {
    left: 14%;
    top: 7%;
  }
}

@media only screen and (max-width: 575px) {
  .livecallsbg {
    display: none;
    padding: 1px 10px !important;
  }

  .mobilelivecalls .livecallsbg {
    display: block;
  }

  .mobiletoggle {
    right: 10%;
  }

  .mobiletoggle .notification-number-badge {
    top: 52%;
    left: 13%;
  }

  .mobiletoggle .whatsappicon-badge {
    top: 36%;
    left: 13%;
  }

  .mobiletoggle .callicon-badge {
    top: 20%;
    left: 13%;
  }

  // .main-inner-screen {
  //   height: 81.5vh;
  // }
}

@media only screen and (max-width: 426px) {
  .mobiletoggle {
    right: 16%;
  }

  // .main-inner-screen {
  //   padding: 20px 2px 0px 0px !important;
  // }
}

.active-indicator {
  background-color: #00ff00;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: absolute;
  right: -5px;
  top: -5px;
}

.inactive-indicator {
  background-color: #ffa500;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: absolute;
  right: -5px;
  top: -5px;
}

.sidebaravatar {
  background-color: $SidebarAvatarBg !important;
  color: $SidebarAvatarColor;
  margin-left: 7px;
}

.header-avatar {
  background-color: $HeaderAvatarBg !important;
  color: $HeaderAvatarColor;
}

.avatar-shape {
  height: 50px !important;
  width: 60px !important;
  border-radius: 50% !important;
  //margin-right: 20px !important;
}

.transfercalldiv {
  .p-inputtext {
    background-color: #242424;
    border: 1px solid #4a4a4a !important;
    padding: 0.5rem 0.5rem;
    width: 100%;
  }
}

.transfercalldiv .p-inputtext:focus {
  border: 1px solid #4a4a4a !important;
}

.transfercalldiv .p-inputtext:hover {
  border: 1px solid #4a4a4a !important;
}

.shorttask {
  padding: 10px;

  .p-inputtext {
    display: flex;
    flex-direction: column;
    background-color: #242424;
    border: 1px solid #4a4a4a !important;
    padding: 0.5rem 0.5rem;
    width: 100%;
  }

  label {
    color: #999999;
    text-transform: capitalize;
    font-size: 14px;
    margin-bottom: 5px;
  }
}
</style>
<style>
#Executive_list .p-dropdown-item {
  font-size: 12px !important;
}

.crm-footer-screen {
  position: absolute;
  bottom: 0px;
  width: 96% !important;
  overflow: hidden;
  z-index: 10;
}

.crmprofilemenu .pi-sign-out {
  color: red !important;
  padding: 8px;
}

@media only screen and (max-width: 768px) {
  .crm-footer-screen {
    display: none;
  }

  .whatsappcontainer {
    height: calc(100vh - 89px);
  }

  .overallchatlistbg .chatlist {
    max-height: calc(100vh - 155px) !important;
  }
}
</style>

<style lang="scss" scoped>
.patientname {
  color: #ffffff;
  font-size: 16px;
  font-weight: 300;
}

.callbg {
  position: fixed;
  top: 60%;
  right: 10px;
  background-color: #4a4a4a;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  z-index: 100;

  img {
    filter: invert(97%) sepia(0%) saturate(12%) hue-rotate(241deg) brightness(89%) contrast(95%);
    width: 20px;
  }
}

.activecallbg {
  position: fixed;
  top: 60%;
  right: 10px;
  background-color: #13b908;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  z-index: 100;

  img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(15%) hue-rotate(300deg) brightness(105%) contrast(104%);
    width: 20px;
  }
}

.calltimerbg {
  background-color: #4a4a4a;
  color: #999999;
  padding: 0 10px;
  width: max-content;
  border-radius: 20px;

  p::before {
    content: " ";
    display: inline-block;
    background-color: #ff5f57;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
}

.shortcalldetailbg {
  position: fixed;
  top: 60%;
  right: 10px;
  background-color: #242424;
  padding: 5px;
  border-radius: 30px;
  width: max-content;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 15px;
  z-index: 100;
}

.shortnamebg {
  background-color: #4a4a4a;
  color: #999999;
  padding: 5px 8px;
  border-radius: 50%;
  display: flex;
  width: max-content;
  text-transform: uppercase;
  font-size: 14px;
}

.fullcalldetailsdiv {
  position: fixed;
  top: 10%;
  right: 10px;
  z-index: 100;

  .closebg {
    display: flex;
    width: 100%;
    justify-content: end;
    margin-bottom: 5px;

    i {
      color: #ffffff;
      font-size: 10px;
      background-color: #242424;
      padding: 5px;
      border-radius: 50%;
    }
  }

  .fullcalldetailsbg {
    background-color: #242424;
    width: 350px;
    border-radius: 10px;
  }
}

.optionbtnbg {
  background-color: #4a4a4a;
  padding: 7px;
  border-radius: 50%;
  display: flex;
  width: max-content;

  img {
    filter: invert(68%) sepia(0%) saturate(781%) hue-rotate(138deg) brightness(90%) contrast(88%);
    width: 30px;
  }
}

.optionbtnbg:active {
  background-color: #0a82ff;
  padding: 7px;
  border-radius: 50%;
  display: flex;
  width: max-content;

  img {
    // filter: invert(100%) sepia(17%) saturate(5124%) hue-rotate(183deg) brightness(123%) contrast(70%);
    filter: brightness(0) saturate(100%) invert(96%) sepia(0%) saturate(16%) hue-rotate(288deg) brightness(105%) contrast(103%);
  }
}

.focusoptionbtnbg {
  background-color: #0a82ff;
  padding: 7px;
  border-radius: 50%;
  display: flex;
  width: max-content;

  img {
    // filter: invert(100%) sepia(17%) saturate(5124%) hue-rotate(183deg) brightness(123%) contrast(70%);
    filter: brightness(0) saturate(100%) invert(96%) sepia(0%) saturate(16%) hue-rotate(288deg) brightness(105%) contrast(103%);
  }
}

.fulltransferlist {
  height: 100px;
  overflow: auto;
}

.transfercontactdiv {
  border: 1px solid #4a4a4a;
  width: 100%;
  color: #999999;
  padding: 5px 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  font-size: 14px;

  .callforwardbg {
    img {
      filter: invert(68%) sepia(0%) saturate(781%) hue-rotate(138deg) brightness(90%) contrast(88%);
      width: 20px;
    }
  }
}

.selectcontactdiv {
  border: 1px solid #999999;
  width: 100%;
  color: #999999;
  padding: 5px 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  font-size: 14px;

  .callforwardbg {
    img {
      filter: invert(68%) sepia(0%) saturate(781%) hue-rotate(138deg) brightness(90%) contrast(88%);
      width: 20px;
    }
  }
}

.attenderdiv {
  background-color: #4a4a4a;
  padding: 5px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #999999;
  border-radius: 0 0 5px 5px;
  margin-top: 5px;

  .shortnamebg {
    background-color: #797979;
    color: #d9d9d9;
  }
}

.adddetailsbg {
  background-color: #4a4a4a;
  padding: 5px 15px;
  border-radius: 30px;
  color: #999999;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;

  i {
    font-size: 12px;
  }
}

.shake {
  animation: shake infinite 2s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {

  0%,
  100% {
    transform: rotate(0deg);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: rotate(20deg);
  }

  20%,
  40%,
  60%,
  80% {
    transform: rotate(-20deg);
  }
}

/* Loading spinner animation */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Module card styles */
.module-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.module-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-color: #d1d5db;
}

.module-card.active:hover {
  border-color: #3b82f6;
}

.module-card.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.module-card.disabled:hover {
  transform: none;
  box-shadow: none;
}

.module-card-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
}

.module-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
}

.module-icon-wrapper i {
  font-size: 1.5rem;
}

.lock-overlay {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 20px;
  height: 20px;
  background: #6b7280;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lock-overlay i {
  font-size: 0.75rem;
  color: white;
}

.module-info {
  flex: 1;
  min-width: 0;
}

.module-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
  line-height: 1.2;
}

.module-description {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0.5rem 0 0 0;
  line-height: 1.4;
}

.module-status {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
}

.module-status.active {
  background: #dcfce7;
  color: #166534;
}

.module-status.inactive {
  background: #fef3c7;
  color: #92400e;
}

.module-status i {
  font-size: 0.75rem;
}

.module-card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #f3f4f6;
}

.module-card-footer i {
  color: #9ca3af;
  font-size: 1rem;
  transition: color 0.2s ease;
}

.module-card:hover .module-card-footer i {
  color: #3b82f6;
}

.module-card.disabled .module-card-footer i {
  color: #d1d5db;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .module-card-content {
    flex-direction: column;
    text-align: center;
  }

  .module-icon-wrapper {
    align-self: center;
  }
}
</style>
